import { Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Box } from "../../common/components";
import { usePageTitle } from "../../common/hooks/usePageTitle";
import RecentJams from "../../components/Home/RecentJams";
import { createStyles, spacing } from "../../styles/theme";
import { useGlobalLoading } from "../../utils/ContextHooks";
import { useTenant } from "../../context/Tenant";

const styles = createStyles({
  container: {
    p: {
      xs: `${spacing.wrapperMobile} ${spacing.wrapperMobile} ${spacing.xlMobile} ${spacing.wrapperMobile}`,
      lg: `${spacing.regularDesktop} ${spacing.largeDesktop} ${spacing.xlDesktop} ${spacing.largeDesktop}`,
    },
    maxHeight: { xs: "calc(100vh - 48px)", lg: "calc(100vh - 50px)" },
    overflowY: "auto",
  },
});

const Home = () => {
  const { t } = useTranslation();
  const { isGloballyLoading } = useGlobalLoading();
  const { tenant } = useTenant();

  usePageTitle("pages.home.title");

  return (
    <Box sx={styles.container} fullWidth>
      <Typography
        data-test="dashboard.title"
        variant="h1"
        mb={{ xs: "32px", lg: "48px" }}
      >
        {isGloballyLoading ? (
          <Skeleton variant="text" width={200} />
        ) : (
          t("HomePage.Welcome", { tenantName: tenant.tenantName })
        )}
      </Typography>
      <Box fullWidth>
        <RecentJams />
      </Box>
    </Box>
  );
};

export default Home;
